// import React from "react";
import { NavLink } from "react-router-dom";

const passion = () => (
    <section className="about-me">
        <div className="row">
            <div className="u-margin-bottom-small">
                <div className="text-align">
                    <h2 className="heading-secondary">
                        A little about me
                    </h2>
                </div>
            </div>
            
            <div className="u-margin-bottom-small">
                <p className="bubble speech">
                    I&apos;m passionate, results oriented, and highly adaptable with over two decades experience in engineering and leadership roles.
                    <br />
                    <br />
                    I have a BSC (Honers) Information Technology and Computing and love all things technical.
                    <br />
                    <br />
                    I should not have a website! But here we are, a project if you like, let&apos;s see where it goes!
                    <br />
                    <br />
                    I have a passion for making and fixing stuff! I especially love creating and maintaining software. It&apos;s something I have been involved in all of my adult life. I&apos;ll share aspects of my work, some learnings, and revelations I&apos;ve had along the way in my work section.
                    <br />
                    <br />
                    From time to time I&apos;ll write about random things so be sure to check out my Blog!
                </p>
            </div>

            <div className="container px-4 py-5" id="featured-3">
                <div className="row g-4 py-5 row-cols-1 row-cols-lg-3">

                    <div className="feature col border border-dark p-4 rounded-3">
                        <div className="feature-icon text-center">
                            <i className="feature-box_icon icon-basic-share" />
                        </div>
                        <h2 className="heading-tertiary heading-tertiary--light u-margin-bottom-small">My Journey</h2>
                            <p className="paragraph paragraph--light">Deep down I&apos;m still that kid building fantastical creations out of lego. Pulling ideas out of my imagination and giving them life, shaping them and solving their problems.</p>
                        <div className="text-center">
                            <NavLink className="feature-box_link" to="/journey" exact>Read more here</NavLink>
                        </div>
                    </div>

                    <div className="feature col border border-dark p-4 rounded-3">
                        <div className="feature-icon text-center">
                            <i className="feature-box_icon icon-basic-book-pen" />
                        </div>
                        <h2 className="heading-tertiary heading-tertiary--light u-margin-bottom-small">My Work</h2>
                            <p className="paragraph paragraph--light">I like to solve problems, the more challenging the better. Sometimes these challenges are organisational involving people and ways of working, and other times it&apos;s technical.</p>
                        <div className="text-center">
                            <NavLink className="feature-box_link" to="/projects" exact>Read more here</NavLink>
                        </div>
                    </div>

                    <div className="feature col border border-dark p-4 rounded-3">
                        <div className="feature-icon text-center">
                            <i className="feature-box_icon icon-basic-lightbulb" />
                        </div>
                        <h2 className="heading-tertiary heading-tertiary--light u-margin-bottom-small">My Blog</h2>
                            <p className="paragraph paragraph--light">I&apos;ve been through a lot (good and bad) both professionally and in my personal life. Each time I face a challenge and learn something about the world and myself. I&apos;d like to share. </p>
                        <div className="text-center">
                            <NavLink className="feature-box_link" to="/blog" exact>Read more here</NavLink>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
)

export default passion;